import { getCachedAzureJwtSub, getCachedStoreProviderId } from './currentUser';

/**
 * Look up a display name from GET /api/v1/store/users/names (providerId → name).
 * Handles legacy rows where updated_by was saved with JWT `sub` instead of Store `oid`.
 */
export function lookupUserDisplayName(
  names: Record<string, string> | undefined,
  providerId: string | null | undefined
): string | undefined {
  if (!names || !providerId) {
    return undefined;
  }
  const trimmed = providerId.trim();
  const direct = names[trimmed] || names[providerId];
  if (direct) {
    return direct;
  }

  const storeProviderId = getCachedStoreProviderId();
  const jwtSub = getCachedAzureJwtSub();
  if (storeProviderId && jwtSub && trimmed === jwtSub) {
    return names[storeProviderId];
  }

  return undefined;
}

/** Initials for avatar chips (first + last word, or first two chars). */
export function userInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }
  if (parts.length === 1 && parts[0].length >= 2) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase() || '?';
}
